import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logoAsset from "@/assets/logo.png.asset.json";

// Public navigation links. Pop-Up is temporarily hidden from the public
// navbar while keeping the route, components, admin tools, and records intact.
const SHOW_POPUP_NAV = false;

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/classes", label: "Classes" },
  { to: "/calendar", label: "Calendar" },
  { to: "/teachers", label: "Instructors" },
  { to: "/open-house", label: "Open House" },
  { to: "/want-to-teach", label: "Want to Teach?" },
  ...(SHOW_POPUP_NAV ? [{ to: "/pop-up", label: "Pop-Up" }] : []),
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <nav style={{ top: "var(--announcement-h, 0px)" }} className="public-site fixed left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-b border-border">
      <div className="container mx-auto flex items-center gap-6 h-14 px-4">
        <Link to="/" className="flex items-center shrink-0" aria-label="Silver Sage Homeschool Hub — Home">
          <img src={logoAsset.url} alt="Silver Sage Homeschool Hub" width={44} height={44} className="block" />
        </Link>

        {/* Desktop */}
        <div className="hidden md:flex flex-1 items-center justify-end gap-x-6 lg:gap-x-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`font-body text-[13px] lg:text-sm font-semibold uppercase tracking-wide whitespace-nowrap transition-colors hover:text-primary ${
                location.pathname === link.to ? "text-primary" : "text-muted-foreground"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Mobile toggle */}
        <button
          onClick={() => setOpen(!open)}
          className="md:hidden ml-auto text-foreground"
          aria-label={open ? "Close menu" : "Open menu"}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-background border-b border-border px-4 pb-4">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setOpen(false)}
              className={`block py-3 font-body text-sm font-semibold uppercase tracking-wide ${
                location.pathname === link.to ? "text-primary" : "text-muted-foreground"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
